export enum TaskEnum {
  UninstallManyTextbookAccesses = 'uninstallManyTextbookAccesses',
}
